import {updateToolCall} from "../../../llm/contextManagement/toolCallUpdater.ts";
import {runOrQueueToolCall} from "../../../llm/responseStream/receiver/toolCallHandlers/toolCallFinish/handlers/appToolCallHandler/ide/ideToolCallHandler.ts";
import {addToolMessage} from "../../../llm/responseStream/receiver/toolCallHandlers/toolCallFinish/utils/utils.ts";

export const handleGiveTerminalOutput = async (data: any, llmRequestRefs: any, currentMessageRef: any, messagesSequenceRef: any, setMessages: any, messagesRef: any, updateElementInProgress: any, environmentObjRef: any) => {
    try {
        const output = data[0];
        const isDone = data[1] === 'true';
        const toolCallId = data[2];

        if (output.trim() !== "") updateToolCall(llmRequestRefs, toolCallId, { output });
        if (isDone) {
            const { id, name, args } = llmRequestRefs.current.toolCalls[toolCallId];
            const lastRealOutput = llmRequestRefs.current.toolCalls[toolCallId].output;

            addToolMessage({ id, name, args }, {output: lastRealOutput}, llmRequestRefs, currentMessageRef, messagesSequenceRef, setMessages, messagesRef);
            updateElementInProgress(toolCallId, 'delete');
            llmRequestRefs.current.toolCallQueue = llmRequestRefs.current.toolCallQueue.filter((toolCall: any) => toolCall.id !== toolCallId);
            await runOrQueueToolCall(llmRequestRefs, "trigger", environmentObjRef, null, null);
        }
    } catch (error) {
        console.error("Error in handleGiveTerminalOutput:", error);
    }
};